'use client';

import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import EquipmentWidgetMobile from '../equipment-widget-mobile/equipment-widget-mobile';
import type { SelectedEquipmentInfo as SelectedEquipmentInfoType } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { usePathMatch } from 'hooks/use-path-match';
import { CURRENT_PAGE } from 'app/[lang]/[esite]/(core)/_header/components/store/constants';

const EquipmentWidgetSelector = ({
  mobileWidgetFlag,
  children,
  widgetContent,
  hasEquipmentsToSelect,
  isEquipmentSelected,
  selectedEquipmentInfo
}: {
  mobileWidgetFlag: boolean;
  selectedEquipmentInfo: SelectedEquipmentInfoType;
  children: React.ReactNode;
  widgetContent: React.ReactNode;
  hasEquipmentsToSelect: boolean;
  isEquipmentSelected: boolean;
}) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const isSearchPage = usePathMatch(CURRENT_PAGE[1].path);

  if (isSearchPage && mobileWidgetFlag && !isMD) {
    return (
      <EquipmentWidgetMobile
        hasEquipmentsToSelect={hasEquipmentsToSelect}
        widgetContent={widgetContent}
        isEquipmentSelected={isEquipmentSelected}
        selectedEquipmentInfo={selectedEquipmentInfo}
      />
    );
  }

  return children;
};

export default EquipmentWidgetSelector;
